import { Directive, Input, ElementRef } from "@angular/core";
import { localStorageKey } from "@core/constants";

@Directive({
  selector: "[appHasPermission]",
})
export class PermissionsDirective {
  constructor(private elementRef: ElementRef) {}

  @Input("appHasPermission")
  set hasPermission(permissions_allow: string[]) {
    const userData = JSON.parse(localStorage.getItem(localStorageKey)).user;
    const permissionsAllowed = [...permissions_allow];
    const userHasPermisson =
      !permissionsAllowed.length ||
      permissionsAllowed.find((p) => userData.permissions.includes(p));
    if (!userHasPermisson) {
      const el: HTMLElement = this.elementRef.nativeElement;
      el.parentNode.removeChild(el);
    }
  }
}
